import { render, staticRenderFns } from "./StudentHomeworkPlanningReport.vue?vue&type=template&id=08b8d0a6"
import script from "./StudentHomeworkPlanningReport.vue?vue&type=script&lang=js"
export * from "./StudentHomeworkPlanningReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports